const labels = {
  'agents:delete': 'mcp_scope_agents_delete',
  'conversations:send': 'mcp_scope_conversations_send',
  'livechat:participate': 'mcp_scope_livechat_participate',
  'livechat:send': 'mcp_scope_livechat_send',
  'livechat:suggest': 'mcp_scope_livechat_suggest',
  'credentials:read': 'mcp_scope_credentials_read',
  'credentials:write': 'mcp_scope_credentials_write',
  'channels:write': 'mcp_scope_channels_write',
  'products:write': 'mcp_scope_products_write',
  'cms:write': 'mcp_scope_cms_write',
  'billing:write': 'mcp_scope_billing_write',
  'livechat:read': 'mcp_scope_livechat_read',
  'livechat:write': 'mcp_scope_livechat_write',
  'conversations:write': 'mcp_scope_conversations_write',
  'notifications:connect': 'mcp_scope_notifications_connect',
  'account:delete': 'mcp_scope_account_delete',
  'account:read': 'mcp_scope_account_read',
  'account:write': 'mcp_scope_account_write',
  'feedback:read': 'mcp_scope_feedback_read',
  'feedback:write': 'mcp_scope_feedback_write',
  'products:read': 'mcp_scope_products_read',
  'cms:read': 'mcp_scope_cms_read',
  'workspaces:create': 'mcp_scope_workspaces_create',
  'workspaces:write': 'mcp_scope_workspaces_write',
  'workspaces:delete': 'mcp_scope_workspaces_delete',
  'members:write': 'mcp_scope_members_write',
  'conversations:export': 'mcp_scope_conversations_export',
  'leads:export': 'mcp_scope_leads_export',
  'leads:delete': 'mcp_scope_leads_delete',
  'knowledge:write': 'mcp_scope_knowledge_write',
  'data_connections:read': 'mcp_scope_data_connections_read',
  'data_connections:write': 'mcp_scope_data_connections_write',
  'integrations:read': 'mcp_scope_integrations_read',
  'integrations:write': 'mcp_scope_integrations_write',
  'channels:read': 'mcp_scope_channels_read',
  'setup:read': 'mcp_scope_setup_read',
  'setup:write': 'mcp_scope_setup_write',
  'widget:read': 'mcp_scope_widget_read',
  'widget:write': 'mcp_scope_widget_write',
  'knowledge:read': 'mcp_scope_knowledge_read',
  'conversations:read': 'mcp_scope_conversations_read',
  'leads:read': 'mcp_scope_leads_read',
  'leads:write': 'mcp_scope_leads_write',
  'reports:read': 'mcp_scope_reports_read',
  'reports:write': 'mcp_scope_reports_write',
  'notifications:read': 'mcp_scope_notifications_read',
  'notifications:write': 'mcp_scope_notifications_write',
  'billing:read': 'mcp_scope_billing_read',
  'workspaces:list': 'mcp_scope_workspaces_list',
  'members:read': 'mcp_scope_members_read',

  'workspaces:read': 'mcp_scope_workspace',
  'agents:read': 'mcp_scope_agents',
  'agents:write': 'mcp_scope_agents_write',
  'agents:context:read': 'mcp_scope_context_read',
  'agents:context:write': 'mcp_scope_context_write',
  'agents:behaviors:read': 'mcp_scope_behaviors_read',
};

export function mcpScopeLabel(scope, t) {
  return labels[scope] ? t(labels[scope]) : scope;
}

// What the consent screen explains about a permission. The texts sit next to the permission they belong to
// (tooltip on a ⚠ or ⓘ symbol) instead of a block under the list; `warn` marks cost, messages sent and deletion.
const notices = [
  [scope => scope === 'billing:write', 'mcp_billing_write_notice', true],
  [scope => ['conversations:send', 'livechat:send', 'livechat:participate'].includes(scope), 'mcp_communication_notice', true],
  [scope => scope === 'agents:delete', 'mcp_agent_delete_notice', true],
  [scope => scope === 'workspaces:delete', 'mcp_workspace_delete_notice', true],
  [scope => scope === 'agents:write', 'mcp_write_notice', false],
  [scope => scope === 'agents:context:write', 'mcp_context_notice', false],
  [scope => /^(widget|leads|reports|notifications|knowledge|data_connections|integrations|setup):write$/.test(scope), 'mcp_management_notice', false],
  [scope => scope.startsWith('credentials:'), 'mcp_credentials_notice', false],
  [scope => scope === 'notifications:connect', 'mcp_notification_connect_notice', false],
  [scope => /^(account|feedback):/.test(scope), 'mcp_account_notice', false],
  [scope => ['workspaces:write', 'workspaces:delete', 'members:write'].includes(scope), 'mcp_team_notice', false],
  [scope => ['data_connections:write', 'integrations:write'].includes(scope), 'mcp_shared_connections_notice', false],
  [scope => scope === 'workspaces:list', 'mcp_workspaces_notice', false],
];

const LEADING = ['workspaces:read', 'agents:read'];
function scopeRank(scope) {
  if (LEADING.includes(scope)) return LEADING.indexOf(scope);
  if (mcpScopeNotices(scope).warn) return 30;
  return /:(read|list)$/.test(scope) ? 10 : 20;
}

// The order permissions are shown in: the basic reads first, other reads, changes, the ⚠ ones last.
export function sortMcpScopes(scopes) {
  return [...(scopes || [])].sort((a, b) => scopeRank(a) - scopeRank(b));
}

export function mcpScopeNotices(scope) {
  const found = notices.filter(([matches]) => matches(scope));
  return { keys: found.map(([, key]) => key), warn: found.some(([, , warn]) => warn) };
}

export function mcpScopeConstraints(scopes, role, allAgents) {
  const personal = ['account:write', 'account:delete', 'feedback:write', 'workspaces:create'];
  const pairs = { 'agents:delete': 'agents:read', 'conversations:send': 'conversations:read',
    'livechat:participate': 'livechat:read', 'livechat:send': 'livechat:read', 'livechat:suggest': 'livechat:read',
    'account:delete': 'account:read', 'notifications:connect': 'notifications:read', 'workspaces:create': 'workspaces:read', 'workspaces:delete': 'workspaces:read',
    'leads:delete': 'leads:read', 'leads:export': 'leads:read', 'conversations:export': 'conversations:read' };
  const missingRead = scopes.some(scope => {
    const required = pairs[scope] || (scope.endsWith(':write') ? scope.replace(/:write$/, ':read') : null);
    return required && !scopes.includes(required);
  });
  const invalidRole = scopes.some(scope =>
    ((scope.endsWith(':write') || ['agents:delete', 'conversations:send', 'leads:delete', 'notifications:connect'].includes(scope)) && !personal.includes(scope) && !['owner', 'admin', 'write'].includes(role)) ||
    (['members:read', 'members:write', 'workspaces:write'].includes(scope) && !['owner', 'admin'].includes(role)) ||
    (scope === 'workspaces:delete' && (role !== 'owner' || !allAgents)));
  return { missingRead, invalidRole };
}
